
// import React, { useEffect, useState } from "react";
// import Header from "../Components/Header";
// import Rightcontainer from "../Components/Rightcontainer";
// import socket from "../Components/socket";
// import { BsWhatsapp, BsTelegram, BsInstagram } from "react-icons/bs";
// import { FaHeadset, FaShieldAlt, FaClock } from "react-icons/fa";

// // --- DREAM11 DARK THEME STYLES ---
// const styles = {
//   pageWrapper: {
//     background: "radial-gradient(circle at top, #1a1a1a, #0a0a0a)",
//     minHeight: "100vh",
//     paddingTop: "90px",
//     fontFamily: "'Inter', sans-serif",
//     color: "#fff"
//   },
//   heroCard: {
//     background: "rgba(30, 30, 30, 0.6)",
//     backdropFilter: "blur(15px)",
//     borderRadius: "30px",
//     padding: "40px 20px",
//     border: "1px solid rgba(255, 255, 255, 0.05)",
//     textAlign: "center",
//     marginBottom: "30px",
//     boxShadow: "0 20px 40px rgba(0,0,0,0.4)"
//   },
//   avatarRing: {
//     width: "120px",
//     height: "120px",
//     borderRadius: "50%",
//     padding: "5px",
//     background: "linear-gradient(180deg, #FF3131 0%, #BA0000 100%)",
//     margin: "0 auto 20px",
//     boxShadow: "0 0 25px rgba(186, 0, 0, 0.4)"
//   },
//   avatarImg: {
//     width: "100%",
//     height: "100%",
//     borderRadius: "50%",
//     objectFit: "cover",
//     backgroundColor: "#1e1e1e"
//   },
//   badgeContainer: {
//     display: "flex",
//     justifyContent: "center",
//     gap: "15px",
//     marginTop: "15px"
//   },
//   badge: {
//     fontSize: "10px",
//     background: "rgba(255,255,255,0.05)",
//     padding: "5px 12px",
//     borderRadius: "20px",
//     color: "#888",
//     display: "flex",
//     alignItems: "center",
//     gap: "5px",
//     border: "1px solid #333"
//   },
//   supportTile: (color) => ({
//     background: "#161616",
//     borderRadius: "24px",
//     padding: "25px 15px",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     textDecoration: "none",
//     border: "1px solid #222",
//     transition: "0.3s",
//     height: "100%",
//     boxShadow: "0 10px 20px rgba(0,0,0,0.2)"
//   }),
//   iconBox: (color) => ({
//     width: "50px",
//     height: "50px",
//     borderRadius: "15px",
//     background: `rgba(${color}, 0.1)`,
//     color: `rgb(${color})`,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "24px",
//     marginBottom: "12px"
//   })
// };

// const Support = () => {
//   const [settingData, setSettingData] = useState();
//   const [settingCk, setSettingCk] = useState({});

//   const telegramLink = "https://t.me/Bajigerludo";
//   const instagramLink = "https://www.instagram.com/";

//   useEffect(() => {
//     const storedSetting = JSON.parse(localStorage.getItem("sitSetting"));
//     if (storedSetting) setSettingData(storedSetting);
//     socket.emit('websetting', '');
//   }, []);

//   useEffect(() => {
//     socket.on("websettingGet", (data) => {
//       localStorage.setItem("sitSetting", JSON.stringify(data));
//       setSettingData(data);
//     });
//     return () => socket.off("websettingGet");
//   }, []);

//   const whatsappLink = settingCk?.whatsappSupport || settingData?.whatsappSupport;

//   return (
//     <>
//       <div className="leftContainer" style={styles.pageWrapper}>
//         <div className="container py-5 Orher_page_main_section">
          
//           {/* Hero Section */}
//           <div style={styles.heroCard}>
//             <div style={styles.avatarRing}>
//               <img
//                 src="images/wsupports.png"
//                 alt="Support"
//                 style={styles.avatarImg}
//               />
//             </div>
//             <h2 className="fw-bold mb-1">Customer Care</h2>
//             <p className="text-muted small px-4">We are available 24/7 to help you with deposits, withdrawals, or gameplay queries.</p>
            
//             <div style={styles.badgeContainer}>
//               <div style={styles.badge}><FaClock color="#FF3131" /> 24x7 Active</div>
//               <div style={styles.badge}><FaShieldAlt color="#4CAF50" /> Secure Help</div>
//             </div>
//           </div>

//           <h6 className="text-center mb-4 text-uppercase fw-bold" style={{letterSpacing: '2px', color: '#444', fontSize: '12px'}}>
//             Select a Platform
//           </h6>

//           {/* Support Grid */}
//           <div className="row g-3">
//             {/* WhatsApp */}
//             {whatsappLink && whatsappLink !== 'null' && (
//               <div className="col-4">
//                 <a
//                   href={`https://wa.me/${whatsappLink}`}
//                   target="_blank"
//                   rel="noreferrer"
//                   style={styles.supportTile()}
//                   onMouseEnter={(e) => e.currentTarget.style.borderColor = '#25D366'}
//                   onMouseLeave={(e) => e.currentTarget.style.borderColor = '#222'}
//                 >
//                   <div style={styles.iconBox('37, 211, 102')}><BsWhatsapp /></div>
//                   <span style={{fontSize: '11px', fontWeight: '700', color: '#fff'}}>WhatsApp</span>
//                 </a>
//               </div>
//             )}

//             {/* Telegram */}
//             <div className="col-4">
//               <a
//                 href={telegramLink}
//                 target="_blank"
//                 rel="noreferrer"
//                 style={styles.supportTile()}
//                 onMouseEnter={(e) => e.currentTarget.style.borderColor = '#0088CC'}
//                 onMouseLeave={(e) => e.currentTarget.style.borderColor = '#222'}
//               >
//                 <div style={styles.iconBox('0, 136, 204')}><BsTelegram /></div>
//                 <span style={{fontSize: '11px', fontWeight: '700', color: '#fff'}}>Telegram</span>
//               </a>
//             </div>

//             {/* Instagram */}
//             <div className="col-4">
//               <a
//                 href={instagramLink}
//                 target="_blank"
//                 rel="noreferrer"
//                 style={styles.supportTile()}
//                 onMouseEnter={(e) => e.currentTarget.style.borderColor = '#E1306C'}
//                 onMouseLeave={(e) => e.currentTarget.style.borderColor = '#222'}
//               >
//                 <div style={styles.iconBox('225, 48, 108')}><BsInstagram /></div>
//                 <span style={{fontSize: '11px', fontWeight: '700', color: '#fff'}}>Instagram</span>
//               </a>
//             </div>
//           </div>

//           {/* Bottom Tip */}
//           <div className="text-center mt-5" style={{opacity: '0.3'}}>
//               <FaHeadset size={20} className="mb-2" />
//               <p style={{fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px'}}>Bajiger Ludo Support Desk</p>
//           </div>
//         </div>
//       </div>

//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </>
//   );
// };

// export default Support;

import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";
import socket from "../Components/socket";
import { BsWhatsapp, BsTelegram, BsInstagram } from "react-icons/bs";
import { FaHeadset, FaShieldAlt, FaClock, FaChevronRight } from "react-icons/fa";

// --- LIGHT THEME STYLES (YELLOW, ORANGE, BLACK) ---
const styles = {
  pageWrapper: {
    background: "#FFFDE7", // Creamy Light Yellow
    minHeight: "100vh",
    // paddingTop: "10px",
    fontFamily: "'Poppins', sans-serif",
    color: "#000",
    paddingBottom:"10%"
  },
  topHeader: {
    background: "#000",
    borderRadius: "0 0 40px 40px",
    padding: "40px 20px 60px",
    textAlign: "center",
    color: "#fff",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
  },
  supportIconCircle: {
    width: "80px",
    height: "80px",
    borderRadius: "24px",
    background: "#FF9800",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "40px",
    color: "#000",
    margin: "0 auto 20px",
    boxShadow: "0 8px 20px rgba(255, 152, 0, 0.3)"
  },
  statusContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginTop: "20px"
  },
  statusBadge: {
    fontSize: "11px",
    fontWeight: "700",
    background: "rgba(255,255,255,0.1)",
    padding: "6px 15px",
    borderRadius: "12px",
    color: "#FFEB3B", // Light Yellow
    display: "flex",
    alignItems: "center",
    gap: "6px",
    border: "1px solid rgba(255,255,255,0.1)"
  },
  platformList: {
    margin: "-30px 20px 0",
    display: "flex",
    flexDirection: "column",
    gap: "15px"
  },
  supportCard: {
    background: "#fff",
    borderRadius: "20px",
    padding: "18px 20px",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: "#000",
    boxShadow: "0 8px 20px rgba(0,0,0,0.04)",
    border: "1px solid #FFF9C4",
    transition: "transform 0.2s ease"
  },
  iconBox: (bgColor) => ({
    width: "50px",
    height: "50px",
    borderRadius: "15px",
    background: bgColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    marginRight: "15px",
    color: "#fff"
  }),
  infoText: {
    flex: 1
  },
  platformName: {
    fontSize: "15px",
    fontWeight: "800",
    display: "block",
    margin: 0
  },
  platformSub: {
    fontSize: "11px",
    color: "#888",
    fontWeight: "500"
  },
  footerNote: {
    textAlign: "center",
    marginTop: "40px",
    color: "#bbb",
    paddingBottom: "30px"
  }
};

const Support = () => {
  const [settingData, setSettingData] = useState();
  const [settingCk, setSettingCk] = useState({});

  const telegramLink = "https://t.me/";
  const instagramLink = "https://www.instagram.com/";

  useEffect(() => {
    const storedSetting = JSON.parse(localStorage.getItem("sitSetting"));
    if (storedSetting) setSettingData(storedSetting);
    socket.emit('websetting', '');
  }, []);

  useEffect(() => {
    socket.on("websettingGet", (data) => {
      localStorage.setItem("sitSetting", JSON.stringify(data));
      setSettingData(data);
    });
    return () => socket.off("websettingGet");
  }, []);

  const whatsappLink = settingCk?.whatsappSupport || settingData?.whatsappSupport;

  return (
    <>
      <div className="leftContainer" style={styles.pageWrapper}>
        <div className="Orher_page_main_sections px-2">
          
          {/* Black Hero Header */}
          <div style={styles.topHeader}>
            <div style={styles.supportIconCircle}>
              <FaHeadset />
            </div>
            <h2 style={{fontWeight: '900', letterSpacing: '-0.5px'}}>Help & Support</h2>
            <p style={{color: '#999', fontSize: '13px', margin: '0 20px'}}>
              Facing issues with Deposit or Withdrawal? Contact us on any platform below.
            </p>
            
            <div style={styles.statusContainer}>
              <div style={styles.statusBadge}><FaClock /> 24/7 Support</div>
              <div style={styles.statusBadge}><FaShieldAlt /> Verified</div>
            </div>
          </div>

          {/* Vertical Platform List */}
          <div style={styles.platformList}>
            
            {/* WhatsApp Card */}
            {whatsappLink && whatsappLink !== 'null' && (
              <a
                href={`https://wa.me/${whatsappLink}`}
                target="_blank"
                rel="noreferrer"
                style={styles.supportCard}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateX(5px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateX(0)'}
              >
                <div style={styles.iconBox('#25D366')}><BsWhatsapp /></div>
                <div style={styles.infoText}>
                  <span style={styles.platformName}>WhatsApp Support</span>
                  <span style={styles.platformSub}>Instant reply within 5 mins</span>
                </div>
                <FaChevronRight color="#eee" />
              </a>
            )}

            {/* Telegram Card */}
            <a
              href={telegramLink}
              target="_blank"
              rel="noreferrer"
              style={styles.supportCard}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateX(5px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateX(0)'}
            >
              <div style={styles.iconBox('#0088CC')}><BsTelegram /></div>
              <div style={styles.infoText}>
                <span style={styles.platformName}>Telegram Channel</span>
                <span style={styles.platformSub}>Get latest game updates</span>
              </div>
              <FaChevronRight color="#eee" />
            </a>

            {/* Instagram Card */}
            <a
              href={instagramLink}
              target="_blank"
              rel="noreferrer"
              style={styles.supportCard}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateX(5px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateX(0)'}
            >
              <div style={styles.iconBox('#E1306C')}><BsInstagram /></div>
              <div style={styles.infoText}>
                <span style={styles.platformName}>Instagram</span>
                <span style={styles.platformSub}>Follow for win announcements</span>
              </div>
              <FaChevronRight color="#eee" />
            </a>
          </div>

          {/* Footer branding */}
          <div style={styles.footerNote}>
              <p style={{fontSize: '10px', fontWeight: '800', letterSpacing: '2px', textTransform: 'uppercase'}}>
                RR Ludo Secure Helpdesk
              </p>
          </div>
        </div>
      </div>

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
};

export default Support;